module.exports = __webpack_public_path__ + "static/media/ic-promo.827d1b99.svg";